/* tslint:disable */
/* eslint-disable */
/**
 * Assemblean Production Solutions
 * Produce the lean way with APCS
 *
 * The version of the OpenAPI document: 0.9.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface APISupplierContact
 */
export interface APISupplierContact {
    /**
     * 
     * @type {string}
     * @memberof APISupplierContact
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof APISupplierContact
     */
    email?: string;
    /**
     * 
     * @type {string}
     * @memberof APISupplierContact
     */
    firstName?: string;
    /**
     * 
     * @type {string}
     * @memberof APISupplierContact
     */
    lastName?: string;
    /**
     * 
     * @type {string}
     * @memberof APISupplierContact
     */
    phone?: string;
    /**
     * 
     * @type {string}
     * @memberof APISupplierContact
     */
    mobile?: string;
    /**
     * 
     * @type {string}
     * @memberof APISupplierContact
     */
    language?: string;
}

/**
 * Check if a given object implements the APISupplierContact interface.
 */
export function instanceOfAPISupplierContact(value: object): value is APISupplierContact {
    if (!('id' in value) || value['id'] === undefined) return false;
    return true;
}

export function APISupplierContactFromJSON(json: any): APISupplierContact {
    return APISupplierContactFromJSONTyped(json, false);
}

export function APISupplierContactFromJSONTyped(json: any, ignoreDiscriminator: boolean): APISupplierContact {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'email': json['email'] == null ? undefined : json['email'],
        'firstName': json['first_name'] == null ? undefined : json['first_name'],
        'lastName': json['last_name'] == null ? undefined : json['last_name'],
        'phone': json['phone'] == null ? undefined : json['phone'],
        'mobile': json['mobile'] == null ? undefined : json['mobile'],
        'language': json['language'] == null ? undefined : json['language'],
    };
}

export function APISupplierContactToJSON(value?: APISupplierContact | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'email': value['email'],
        'first_name': value['firstName'],
        'last_name': value['lastName'],
        'phone': value['phone'],
        'mobile': value['mobile'],
        'language': value['language'],
    };
}

